import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Layout, Dropdown, Avatar } from "antd";
import Gravatar from "react-gravatar";
import get from "lodash/get";
import { DownOutlined } from "@ant-design/icons";
import { getMenuItems } from "../../utilities/layout";
import { useNavigate } from "react-router-dom";
import { logout } from "../../redux/actions/authActions";

const { Header } = Layout;

const LayoutHeader = () => {
  const auth = useSelector((state) => get(state, "auth"));
  const user = get(auth, "user");
  const dispatch = useDispatch();
  const onClickLogout = () => {
    dispatch(logout());
  };

  return (
    <Header
      style={{
        padding: 0,
        height: 73,
      }}
    >
      <div className=" flex h-full">
        <div className="flex flex-row justify-end items-center space-x-5 px-10 h-full w-full flex-1 ">
          <Dropdown
            menu={{
              items: getMenuItems(onClickLogout),
            }}
            placement="bottom"
          >
            <div className="flex flex-row items-center justify-center  h-full hover:cursor-pointer min-w-28">
              <Avatar
                className="avtaar"
                icon={<Gravatar email={get(user, "email")} size={20} />}
              />
              <span className="text-black font-semibold text-base items-center pr-4 pl-1  ">
                {get(user, "name")}
              </span>

              <DownOutlined className="text-primary" />
            </div>
          </Dropdown>
        </div>
      </div>
    </Header>
  );
};

export default LayoutHeader;
